import React from 'react';

import { ContestManageContextProvider } from '../common/context/ContestManageContext';
import ContestManageModalsContextProvider from '../common/components/Modals/ContestManageModalsProvider';

import { Sections } from './sections/Sections';

function ContestCreatePage() {
  return (
    <ContestManageContextProvider operation="create">
      <ContestManageModalsContextProvider>
        <Sections />
      </ContestManageModalsContextProvider>
    </ContestManageContextProvider>
  );
}

export default ContestCreatePage;
